"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validators = void 0;
var _store = _interopRequireDefault(require("./store"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var validators = new _store.default();
exports.validators = validators;
if (process.env.NODE_ENV === 'development') {
  Object.assign(validators, {
    _name: 'Validators'
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vxe-table@3.7.6/~/vxe-table/lib/v-x-e-table/src/validators.js
// module id = 1030
// module chunks = 75